import "./OrderSummary.css";
import getImageUrl from "../../utils/imageUrl";

function OrderSummary({
  cart = [],
  removeItem,
  isCateringOrder = false,
  cateringGuests = 0,
}) {

  // =========================================================
  // GET ACTUAL ITEM PRICE
  // =========================================================

  const getItemPrice = (item) => {

    const food =
      item?.foodId || {};

    const original =
      item?.originalItem || {};

    const candidates = [

      item?.price,

      item?.total,

      food?.price,

      food?.offerPrice,

      food?.menuPrice,

      original?.price,

      original?.total,

      original?.menuPrice,

      original?.quotedPrice,

      original?.finalPrice,

      original?.unitPrice,

      original?.itemPrice,

      original?.cateringPrice,

      original?.offerPrice,

    ];

    for (const candidate of candidates) {

      const value =
        Number(candidate);

      if (
        Number.isFinite(value) &&
        value > 0
      ) {

        return value;

      }

    }

    return 0;

  };


  // =========================================================
  // SUBTOTAL
  // =========================================================

  const subtotal =
    cart.reduce(
      (sum, item) => {

        const price =
          getItemPrice(item);

        const quantity =
          isCateringOrder
            ? 1
            : (
                Number(
                  item?.quantity
                ) || 1
              );

        return (
          sum +
          price * quantity
        );

      },
      0
    );


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <section className="order-summary-section">

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="order-summary-header">

        <div className="order-summary-heading">

          <div className="order-summary-icon">
            📦
          </div>

          <div>

            <h2>
              Order Summary
            </h2>

            <p>
              Review the items in your cart before placing your order.
            </p>

          </div>

        </div>


        <div className="order-item-count">

          {cart.length} Item
          {cart.length !== 1 ? "s" : ""}

        </div>

      </div>


      {/* =====================================================
          EMPTY
      ===================================================== */}

      {cart.length === 0 ? (

        <div className="order-empty-cart">

          <div className="order-empty-icon">
            🛒
          </div>

          <h3>
            Your cart is empty
          </h3>

          <p>
            Explore delicious homemade food and add your favorite dishes.
          </p>

        </div>

      ) : (

        <>

          {/* =================================================
              ORDER ITEMS
          ================================================= */}

          <div className="order-list">

            {cart.map(
              (item, index) => {

                const food =
                  item?.foodId || {};

                const original =
                  item?.originalItem || {};


                // =================================================
                // ACTUAL PRICE
                // =================================================

                const price =
                  getItemPrice(item);


                // =================================================
                // QUANTITY
                // =================================================

                const quantity =
                  isCateringOrder
                    ? 1
                    : (
                        Number(
                          item?.quantity
                        ) || 1
                      );


                // =================================================
                // ITEM TOTAL
                // =================================================

                const total =
                  price * quantity;


                // =================================================
                // NAME
                // =================================================

                const foodName =

                  food?.foodName ||

                  food?.name ||

                  original?.foodName ||

                  original?.itemName ||

                  item?.foodName ||

                  item?.itemName ||

                  "Food Item";


                // =================================================
                // IMAGE
                // =================================================

                const image =

                  food?.image ||

                  original?.image ||

                  item?.image ||

                  "";


                // =================================================
                // PROVIDER NAME
                // =================================================

                const providerName =

                  food?.providerId
                    ?.business
                    ?.businessName ||

                  original?.providerSnapshot
                    ?.businessName ||

                  "HomeFoods";


                return (

                  <div
                    className="order-food-item"
                    key={
                      item?._id ||
                      original?._id ||
                      `checkout-item-${index}`
                    }
                  >

                    {/* =================================================
                        LEFT
                    ================================================= */}

                    <div className="order-food-left">

                      <div className="order-food-image-wrapper">

                        <img
                          src={
                            getImageUrl(image) ||
                            "/images/default-food.jpg"
                          }
                          alt={
                            foodName ||
                            "Food"
                          }
                          className="order-food-image"
                          onError={(e) => {

                            e.currentTarget.src =
                              "/images/default-food.jpg";

                          }}
                        />

                      </div>


                      <div className="order-food-details">

                        <h3>
                          {foodName}
                        </h3>


                        <p className="order-provider-name">

                          {providerName}

                        </p>


                        {/* =================================================
                            CATERING
                        ================================================= */}

                        {isCateringOrder ? (

                          <div className="order-food-price">

                            <span>
                              ₹{price.toFixed(2)}
                            </span>

                            <span className="price-separator">
                              •
                            </span>

                            <span>
                              {cateringGuests || "—"} guests
                            </span>

                          </div>

                        ) : (

                          /* =================================================
                             NORMAL ORDER
                          ================================================= */

                          <div className="order-food-price">

                            <span>
                              ₹{price.toFixed(2)}
                            </span>

                            <span className="price-separator">
                              ×
                            </span>

                            <span>
                              {quantity}
                            </span>

                          </div>

                        )}

                      </div>

                    </div>


                    {/* =================================================
                        RIGHT
                    ================================================= */}

                    <div className="order-food-right">

                      <h3>

                        ₹{total.toFixed(2)}

                      </h3>


                      <button
                        type="button"
                        className="order-remove-btn"
                        onClick={() =>
                          removeItem(
                            item?._id
                          )
                        }
                      >

                        🗑 Remove

                      </button>

                    </div>

                  </div>

                );

              }
            )}

          </div>


          {/* =================================================
              CART TOTAL
          ================================================= */}

          <div className="order-subtotal">

            <div className="order-subtotal-left">

              <span className="order-subtotal-title">

                {isCateringOrder
                  ? "Menu Total"
                  : "Cart Total"}

              </span>


              <span className="order-subtotal-items">

                {cart.length} Item
                {cart.length !== 1 ? "s" : ""}

              </span>

            </div>


            <div className="order-subtotal-price">

              ₹{subtotal.toFixed(2)}

            </div>

          </div>

        </>

      )}

    </section>

  );

}


export default OrderSummary;